<template>
  <div :class="classes">
    <div class="vi-help--title">
      <div class="vi-help--title__text">帮助引导</div>
      <div class="vi-help--title__more"><a href="javascript:" @click="() => $refs.helpFeatures.onToPath()">更多</a></div>
    </div>
    <!--功能介绍-->
    <div class="vi-help--features">
      <m-help-features v-if="!isHelpData" ref="helpFeatures" :data="helpData.helpDataRespDTOList.find(v => v.type === 1)"/>
    </div>
    <!--使用指南-->
    <div class="vi-help--guide">
      <m-help-guide v-if="!isHelpData" :data="helpData.helpDataRespDTOList.find(v => v.type === 2)"/>
    </div>
    <!--常见问题-->
    <div class="vi-help--problem">
      <m-help-problem v-if="!isHelpData" :data="helpData.questionList"/>
    </div>
    <!--运营指导-->
    <div class="vi-help--direction">
      <m-help-guide v-if="!isHelpData" :data="helpData.helpDataRespDTOList.find(v => v.type === 3)"/>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import mHelpFeatures from './helpFeatures'
  import mHelpGuide from './helpGuide'
  import mHelpProblem from './helpProblem'
  import HelpCentreService from '@/module/apis/helpCentreService'

  const prefixCls = 'vi-help'
  export default {
    name: 'help',
    data () {
      return {
        helpData: {},
        isHelpData: false
      }
    },
    props: {},
    methods: {
      getData () {
        this.isHelpData = true
        const { reId } = this.helpParams
        HelpCentreService.queryHelpData(reId).then(res => {
          this.helpData = res.data
          this.isHelpData = false
        }).catch(() => {
          this.isHelpData = false
        })
      }
    },
    watch: {},
    beforeCreate () {
    },
    created () {
      this.getData()
    },
    beforeMount () {
    },
    mounted () {
    },
    beforeUpdate () {
    },
    updated () {
    },
    beforeDestroy () {
    },
    destroyed () {
    },
    computed: {
      ...mapState('common', ['helpParams']),
      classes () {
        return [
          `scrollbar`,
          `${prefixCls}`
        ]
      }
    },
    components: { mHelpFeatures, mHelpGuide, mHelpProblem }
  }
</script>

<style lang="scss" rel="stylesheet/scss">
  $-prefix-cls: "vi-help";
  .#{$-prefix-cls} {
    padding:10px 16px;
    height: calc(100vh - 62px);
    background: #fff;
    &--title {
      padding: 10px 0px;
      position: relative;
      z-index: 1;
      &__text {
        font-size: 16px;
        color: #303030;
      }
      &__more {
        position: absolute;
        right: 0;
        top: 12px;
        a {
          font-size: 14px;
          color: #4F88FF;
          text-decoration: none;
        }
      }
    }
    &--item {
      &__title {
        padding: 10px 0;
        b {
          font-weight: bold;
          font-size: 15px;
          color: #303030;
        }
      }
      &__more {
        margin: 6px 0;
        a {
          font-size: 12px;
          color: #4F88FF;
          text-decoration: none;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/js/module/layout/_source/help.vue